const Dash = (props) => {
    const pathFill = props.fill || 'black';
    const pathStroke = props.stroke || 'inherit';
    const strokeWidth = props.strokeWidth || '1px';
    const iconWidth = props.width || 8
    const iconHeight = props.height || 2

    return <>
        <svg style={props.style} width={iconWidth} height={iconHeight} viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.33317 1.53569H0.666504V0.583313H7.33317V1.53569Z" fill={pathFill} stroke={pathStroke} strokeWidth={strokeWidth} />
        </svg>
    </>
}
export default Dash
